// Fronted/src/contexts/MinistryContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import MinistryService from '../services/ministryService';
const MinistryContext = createContext();

export const useMinistries = () => {
  return useContext(MinistryContext);
};

export const MinistryProvider = ({ children }) => {
  const [ministries, setMinistries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMinistries = async () => {
      try {
        setLoading(true);
        const response = await MinistryService.getAllMinistries();
        
        if (response.length <= 0) {
          throw new Error('Failed to fetch ministries');
        }
        
        setMinistries(response || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching ministries:', err);
        setError('Failed to load ministries. Please try again later.');
        // Fallback to mock data if API fails
       
      } finally {
        setLoading(false);
      }
    };

    /*const refreshMinistries = async () => {
    try {
      setLoading(true);
      const data = await MinistryService.getAllMinistries();
      setMinistries(data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
    refreshMinistries();*/
    fetchMinistries();
  }, []);

  const value = {
    ministries,
    loading,
    error,
    setMinistries
  };

  return (
    <MinistryContext.Provider value={value}>
      {children}
    </MinistryContext.Provider>
  );
};

export default MinistryContext; 